<div [formGroup]="form">
    <div class="row">
        <div class="col-md-6 col-xs-12">
            <div class="controls-group">                        
                <label mandatory>
                    סטטוס בארץ
                </label>
                <div class="input-group">
                    <select class="form-control" formControlName="israely_status" (change)="statusChanged()">
                        <option value="" disabled selected>בחר סטטוס בארץ</option>
                        <option *ngFor="let item of baseService.IsraelyStatus" value="{{item.KOD}}">{{item.TEUR}}</option>
                    </select>                                            
                    <span class="input-group-prepend">
                        <span class="input-group-text" >
                            <i class="fa fa-angle-down fa-lg"></i>
                        </span>
                    </span>    
                    <control-messages [control]="f.israely_status"></control-messages>
                </div>
            </div>
            <div class="controls-group" *ngIf="v.israely_status == '1'">                        
                <label mandatory>
                    תאריך יציאה
                </label>
                <div class="input-group">
                    <input type="text" class="form-control datepicker" autocomplete="off" 
                        bsDatepicker [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"
                        #dpd="bsDatepicker" formControlName="departure_date" 
                    >
                    <span class="input-group-prepend">
                        <span class="input-group-text" >
                            <i class="fa fa-calendar"></i>
                        </span>
                    </span>
                    <control-messages [control]="f.departure_date"></control-messages>
                </div>
            </div>
            <div class="controls-group" *ngIf="!isForChild && v.israely_status == '1'">                        
                <label mandatory>
                    שירות צבאי
                </label>
                <div class="input-group">
                    <select class="form-control" formControlName="army_service" (change)="armyServiceChanged()" >
                        <option value="" disabled selected> בחר שירות צבאי </option>
                        <option *ngFor="let item of baseService.ArmyServices" value="{{item.KOD}}">{{item.TEUR}}</option>
                    </select>
                    <span class="input-group-prepend">
                        <span class="input-group-text" >
                            <i class="fa fa-angle-down fa-lg"></i>
                        </span>
                    </span>    
                    <control-messages [control]="f.army_service"></control-messages>
                </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="v.israely_status == '1' && (('1' == v.army_service) || ('5' == v.army_service))">
        <div class="col-md-12 col-xs-12">
                <div class="controls-group">                        
                    <div class="input-group">
                            <textarea type="text" class="form-control txt" 
                                formControlName="content" maxlength="600"
                                placeholder="יש לכתוב הסבר"
                            >
                            </textarea>
                            <control-messages [control]="f.content"></control-messages>
                        </div>
                </div>
        </div>
    </div>
    <div class="row" *ngIf="!isForChild && v.israely_status == '1'">
        <div class="col-md-12 col-xs-12">
            <div class="row">
                <div class="col-md-12 col-xs-12">
                    <yes-no [form]="form" controlName="gov_check" 
                        text="בחמש השנים לפני חזרתי ארצה, הועסקתי על ידי משרד ממשלתי ו/או מעסיק ישראלי, כך ששולמו עבור עבודתי מיסים לרשויות המס בישראל">
                    </yes-no>
                </div>
            </div>
        </div>
    </div>
</div>